import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Info, AlertTriangle, CheckCircle, XCircle, Gift } from "lucide-react";
import type { PlatformAnnouncement } from "@/hooks/useTenantAnnouncements";

interface AnnouncementModalProps {
  announcement: PlatformAnnouncement;
  onDismiss: () => void;
  onAcknowledge: () => void;
}

const typeIcons: Record<string, React.ReactNode> = {
  info: <Info className="h-6 w-6 text-blue-500" />,
  warning: <AlertTriangle className="h-6 w-6 text-yellow-500" />,
  success: <CheckCircle className="h-6 w-6 text-green-500" />,
  error: <XCircle className="h-6 w-6 text-destructive" />,
  promotion: <Gift className="h-6 w-6 text-purple-500" />,
};

export const AnnouncementModal = ({ announcement, onDismiss, onAcknowledge }: AnnouncementModalProps) => {
  return (
    <Dialog open onOpenChange={(open) => { if (!open && announcement.is_dismissible) onDismiss(); }}>
      <DialogContent className="sm:max-w-md" onPointerDownOutside={(e) => {
        if (announcement.require_acknowledgment) e.preventDefault();
      }}>
        <DialogHeader>
          <div className="flex items-center gap-3">
            {typeIcons[announcement.type]}
            <DialogTitle>{announcement.title}</DialogTitle>
          </div>
          <DialogDescription className="pt-2 whitespace-pre-wrap">
            {announcement.content}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          {announcement.require_acknowledgment ? (
            <Button onClick={onAcknowledge} className="w-full sm:w-auto">
              I Understand
            </Button>
          ) : (
            <Button variant="outline" onClick={onDismiss}>
              Dismiss
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
